<template>
	<el-input-number
		:value="selfData"
		:min="tableData.min"
		:max="tableData.max"
		:size="tableData.size"
		@change="handleChange"
	></el-input-number>
</template>
<script>
export default {
	props: ['scope', 'tableData'],
	data() {
		return {
			selfData: this.scope.row[this.tableData.bind],
		};
	},
	methods: {
		handleChange(val, oldVal) {
			this.selfData = val;
			let { scope, tableData } = this;
			tableData.change && tableData.change(val, oldVal, scope.row, tableData);
		},
	},
	watch: {
		'scope.row': {
			handler(val) {
				this.selfData = val[this.tableData.bind];
			},
			immediate: true,
			deep: true,
		},
	},
};
</script>
